export default __webpack_public_path__ + "9d5328fb490cddd43f6698012123404b.png";